import { 
    getCurrentProfile,
    logout,
}
    from './profileActions';

// import {
//      getCurrentAuthAction,
// }
//     from './UnityAuthenticationAction';

import {
    getFlags,
}
    from './featureFlagActions';

import {
    searchStreams,
    checkShareFaithEmail,
} from './integrationsActions';

import {
    getProject,
    getProjects,
    createProject,
    changeProjects,
    getLiveProjectConfig,
}
    from './projectActions';

import {
    checkProjectConfig,
}
    from './projectConfigActions';

import {
    getEmbedCode,
}
    from './organizationActions';

import {
    getVimeoFeeds,
    getVimeoToken,
} from './vimeoActions';

import {
    getProjectVersion,
    updateProjectVersion,
    updateProjectVersionbyParameter,
    deleteProjectVersion,
    updateProjectVersionWithMedia,
    publishProject,
    togglePreviewShown,
    updateProjectVersionForSermonDisconnect,
}
    from './projectVersionsActions';

import {
    getTemplates,
    getTemplate,
}
    from './templateActions';

import {
    getProjectVersionModules,
    updateModule,
    updateModuleParameter,
    getModuleByType,
    getModuleByTypeAndForms,
    bulkUpdateModules,
}
    from './moduleActions';

import {
    getProjectVersionMenuItems,
    updateMenuItemParameter,
    bulkUpdateMenuItems,
} from './menuItemActions';

import {
    getProjectMedia,
}
    from './mediaActions';
import {
    getPagesforDropdown,
    getPagesforProject,
    deleteContentSection,
    addContentSectionToPage,
    reorderPageSections,
    updateContentSection,
    addContentToSection,
    updateContent,
    deleteContent,
    deletePage,
    addPage,
    updatePage,
} from './contentActions';

import {
    getForms,
}
    from './FmsActions';

import {
    addAlert,
    clearAlert,
} from './alertActions';

import {
    createMessage,
    updateMessage,
    deleteMessage,
    getMessages,
    getMessage,
    getMessagesTotal,
} from './messageActions';

// ONLY FOR CROP
import {
    deleteSingleImageForCrop,
    cropImageForCrop,
    uploadAssetImageForCrop,
    getOriginalCroppedImageForCrop,
    getOriginalImageForCrop,
    deleteImagesForCropForCrop,
    resetWarning,
    resetCroppedImage,
    resetImageData,
    clearCropModal,
}
    from './cropActions';

import {
    getCloverProducts,
    getCloverProductPages,
    setSelectedCloverPage,
    disconnectCloverAccount,
}
    from './cloverActions';

import {
    setMenuOpenSection,
    toggleMenuShown,
    toggleMobileMenuShown,
}
    from './menuActions';

import {
    getChmsCalendarFeeds,
} from './calendarActions';

import { getWaffleToken } from './waffleActions';

import {
    getStudioCConfiguration,
}
    from './studiocActions';

export default {
    logout,
    changeProjects,
    getCurrentProfile,
    getProject,
    getProjects,
    createProject,
    getProjectVersion,
    updateProjectVersion,
    updateProjectVersionbyParameter,
    deleteProjectVersion,
    updateProjectVersionForSermonDisconnect,
    getTemplates,
    getTemplate,
    getProjectVersionModules,
    updateModule,
    updateModuleParameter,
    getModuleByType,
    getModuleByTypeAndForms,
    getForms,
    getProjectMedia,
    updateProjectVersionWithMedia,
    addAlert,
    clearAlert,
    bulkUpdateModules,
    getEmbedCode,
    getLiveProjectConfig,
    getChmsCalendarFeeds,
    getWaffleToken,

    // ONLY FOR CROP
    deleteSingleImageForCrop,
    cropImageForCrop,
    uploadAssetImageForCrop,
    getOriginalCroppedImageForCrop,
    getOriginalImageForCrop,
    deleteImagesForCropForCrop,
    resetWarning,
    resetCroppedImage,
    resetImageData,
    clearCropModal,

    // project config
    checkProjectConfig,
    publishProject,
    getCloverProducts,
    getCloverProductPages,
    setSelectedCloverPage,
    disconnectCloverAccount,
    setMenuOpenSection,
    toggleMenuShown,
    toggleMobileMenuShown,
    togglePreviewShown,

    // messages
    createMessage,
    updateMessage,
    deleteMessage,
    getMessages,
    getMessage,
    getMessagesTotal,

    searchStreams,
    checkShareFaithEmail,
    getFlags,

    // menuItems
    getProjectVersionMenuItems,
    updateMenuItemParameter,
    bulkUpdateMenuItems,

    getVimeoFeeds,
    getVimeoToken,

    addContentSectionToPage,
    getPagesforProject,
    getPagesforDropdown,
    deleteContentSection,
    reorderPageSections,
    updateContentSection,
    addContentToSection,
    updateContent,
    deleteContent,
    deletePage,
    addPage,
    updatePage,
    getStudioCConfiguration
    // Unity
    //  getCurrentAuthAction,
};
